var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-editor"},[_c('VueImageInput',{attrs:{"data":_vm.editorData}}),_c('VueImageCropper',{attrs:{"data":_vm.editorData,"cropperOptions":_vm.cropperOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }